export const Monogram = ({ className = "h-9 w-9" }) => (
  <svg viewBox="0 0 48 48" fill="none" className={className} aria-hidden="true" data-testid="monogram-logo">
    <rect x="1.25" y="1.25" width="45.5" height="45.5" rx="12" stroke="currentColor" strokeWidth="1.5" />
    <text
      x="24"
      y="30.5"
      textAnchor="middle"
      fontFamily="Cormorant Garamond, Georgia, serif"
      fontStyle="italic"
      fontSize="19"
      fill="currentColor"
    >
      SP
    </text>
  </svg>
);

export default Monogram;
